import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import BaseFormField from '../base-form-field';
import YesNoRadio from '../yes-no-radio';
import { AddFunnelPropFromContext } from '../funnel-context';
const LABELS = {
  ARHI: DEFAULT_LABELS.TRANSFERRING_FUNDS_RADIO,
  IWHI: 'Do you currently have Australian health insurance?',
  IMAN: 'Do you currently have Australian health insurance?',
  ISHI: 'Do you currently have OSHC health insurance?'
};
const DEPENDANTS_RADIO_OPTIONS = {
  YesPolicyHolder: 'Yes - on my cover',
  YesPartner: "Yes - on my partner's cover",
  YesDifferentFund: 'Yes - on a different cover',
  No: 'No'
};
const LABELS_DEPENDANT = {
  ARHI: DEFAULT_LABELS.CHILD_TRANSFERRING_FUNDS_RADIO
};
export const TransferringFundsRadio = _ref => {
  let {
    label,
    funnel = FUNNELS.ARHI,
    help = '',
    options,
    ...otherProps
  } = _ref;
  return React.createElement(YesNoRadio, {
    name: "TransferringFundsRadioYesNo",
    label: label || LABELS[funnel] || LABELS.ARHI,
    help: help,
    funnel: funnel,
    ...otherProps,
    options: options
  });
};
const buildDependantsRadioOptions = _ref2 => {
  let {
    policyHolderHasPreviousFund,
    partnerHasPreviousFund
  } = _ref2;
  const dependantsRadioOptions = {
    ...DEPENDANTS_RADIO_OPTIONS
  };
  // Hide Yes - policy holder cover if no cover
  if (!policyHolderHasPreviousFund) delete dependantsRadioOptions.YesPolicyHolder;
  // Hide Yes - partner cover if no cover
  if (!partnerHasPreviousFund) delete dependantsRadioOptions.YesPartner;
  // Show yes if none
  if (!policyHolderHasPreviousFund && !partnerHasPreviousFund) {
    dependantsRadioOptions.YesDifferentFund = 'Yes';
  }
  return dependantsRadioOptions;
};
export const TransferringFundsDependant = props => {
  return React.createElement(BaseFormField, {
    required: props.required,
    label: LABELS_DEPENDANT.ARHI,
    ...props
  }, React.createElement(RadioGroup, {
    inline: !props.policyHolderHasPreviousFund && !props.partnerHasPreviousFund,
    options: buildDependantsRadioOptions(props)
  }));
};
const TransferringFundsRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, props.isDependant ? React.createElement(TransferringFundsDependant, {
  ...props
}) : React.createElement(TransferringFundsRadio, {
  ...props
}));
export default TransferringFundsRadioWithFunnel;